import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IComplexDate } from '@ph-shared/utils/date-control-formater';

/*
 * Required Validator for any field except DATES
 * */
export function RequiredValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value;

  if (value === null || value === '' || value === undefined || (value && value.toString().trim() === '')) {
    return {
      required: true,
      errorMessage: 'errors.required',
    };
  }

  return null;
}

/*
 * Required Validator for any field except DATES
 * */
export function RequiredDateValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value;
  if (value === null || value === '' || value === undefined) {
    return {
      required: true,
      errorMessage: 'errors.dateFormat',
    };
  }

  return null;
}

export function DateRangeValidator(dateRange: [number, number]): ValidatorFn {
  return (control: AbstractControl<IComplexDate>): ValidationErrors | null => {
    const value = control.value?.formattedUS;
    if (value) {
      const [min, max] = dateRange;
      const minDate = new Date();
      minDate.setDate(minDate.getDate() - min);
      minDate.setHours(0,0,0,0);

      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + max);
      maxDate.setHours(0,0,0,0);

      const selectedDate = new Date(value);

      if (selectedDate > maxDate || selectedDate < minDate) {
        return {
          required: true,
          errorMessage: 'errors.dateRange',
        };
      }

      return null;
    }

    return null;
  };
}

export function ZipCodeValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value ? control.value.toUpperCase() : null;
  const ZIPCODE_REGEX =
    /(^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/;
  if (value && !ZIPCODE_REGEX.test(value)) {
    return {
      required: true,
      errorMessage: 'errors.zipCode',
    };
  }

  return null;
}

export function EmailValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value;
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (value && !EMAIL_REGEX.test(value)) {
    return {
      required: true,
      errorMessage: 'errors.email',
    };
  }

  return null;
}

export function NumberValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value;

  if (value && (isNaN(value) || value.toString().toLowerCase().includes('e'))) {
    return {
      required: true,
      errorMessage: 'errors.numbersOnly',
    };
  }

  return null;
}

export function IntegerValidator(control: AbstractControl): null | { required: boolean; errorMessage: string } {
  const value = control.value;
  const numberPattern = /^[0-9]+$/;

  if (value && !value.match(numberPattern)) {
    return {
      required: true,
      errorMessage: 'errors.numbersOnly',
    };
  }

  return null;
}

export function GreaterThanZeroNumberValidator(
  control: AbstractControl
): null | { required: boolean; errorMessage: string } {
  const value = control.value;

  if (value?.length && typeof +value === 'number' && value <= 0) {
    return {
      required: true,
      errorMessage: 'Value must be greater than 0',
    };
  }

  return null;
}
